// ResizeControl.js
import Control from 'ol/control/Control';

class ResizeControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const button = document.createElement('button');
    button.innerHTML = '';
    button.className = 'mapSize-button fa fa-expand-alt';

    const element = document.createElement('div');
    element.className = 'resize-control ol-unselectable ol-control';
    element.style.padding = '4px';
    element.style.left = '0.5em';
    element.style.top = '0.5em';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    button.addEventListener('click', this.handleResize.bind(this), false);
  }

  handleResize() {
    const mapElement = document.getElementsByClassName('map-root').item(0);
    if (mapElement.style.height === '50vh') {
      mapElement.style.height = '80vh';
    } else {
      mapElement.style.height = '50vh';
    }
    this.getMap().updateSize();
  }
}

export default ResizeControl;
